import { useCallback } from 'react'
import Checkbox from '@mui/material/Checkbox'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import { array, number, func, string } from 'prop-types'

export const EnhancedTableHeader = ({
  columns,
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
}) => {
  const createSortHandler = useCallback(
    (property, index) => event => {
      onRequestSort(event, property.label, index)
    },
    [onRequestSort],
  )

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox" style={{ backgroundColor: 'white' }}>
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'Select all desserts' }}
          />
        </TableCell>
        {columns.map((row, index) => (
          <TableCell
            style={{ backgroundColor: 'white', width: row.width ? row.width : 'initial' }}
            key={row.label}
            align={row ? 'left' : 'right'}
            padding="normal"
            sortDirection={orderBy === row ? order : false}
          >
            <TableSortLabel
              active={orderBy === row}
              direction={order}
              onClick={createSortHandler(row, index)}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHeader.propTypes = {
  columns: array.isRequired,
  numSelected: number.isRequired,
  onRequestSort: func.isRequired,
  onSelectAllClick: func.isRequired,
  order: string.isRequired,
  orderBy: string.isRequired,
  rowCount: number.isRequired,
}
